import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { EdVibanApi, EdVibanView } from '../tokens/ed-viban.token';

/**
 * REST implementation of the E-D V-IBAN & Payments API (PRD §3.13, EM-845).
 *
 *   GET /services/embedded/api/v1/ed/viban
 *
 * Read-only, E-D-scoped server-side (Rule 22). REST-only (Rules 07/10). Bound to ED_VIBAN.
 */
@Injectable({ providedIn: 'root' })
export class EdVibanRestService implements EdVibanApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed/viban`;

  getViban(): Observable<EdVibanView> {
    return this.http.get<EdVibanView>(this.base);
  }
}
